import { Field, IconButton, Modal, TextInput } from "@carbon6/c6-frontend-design";
import styles from "./ConfirmModal.module.css";

type DismissCandidateModalProps = {
  sourceRef: string;
  reason: string;
  errorMessage: string | null;
  submitting: boolean;
  onCancel: () => void;
  onReasonChange: (reason: string) => void;
  onConfirm: () => void;
};

/**
 * 폐기 확인.
 *
 * 폐기는 **되돌릴 수 없다** — 훑기가 같은 주소를 다시 봐도 제안하지 않는다. 그래서 숨김과 달리
 * 위험 톤을 쓰고 사유를 받는다. 사유는 나중에 "왜 이건 안 올렸지" 를 답하는 유일한 기록이다.
 */
export function DismissCandidateModal({
  errorMessage,
  onCancel,
  onConfirm,
  onReasonChange,
  reason,
  sourceRef,
  submitting,
}: DismissCandidateModalProps) {
  return (
    <Modal
      open
      closeOnBackdropClick={!submitting}
      closeOnEscape={!submitting}
      size="sm"
      onClose={onCancel}
    >
      <Modal.Header>
        <Modal.Header.Start>
          <Modal.Header.Title>후보 폐기</Modal.Header.Title>
        </Modal.Header.Start>
        <Modal.Header.End>
          <Modal.Header.Close disabled={submitting} label="닫기" />
        </Modal.Header.End>
      </Modal.Header>
      <Modal.Body>
        <p className={styles.eyebrow}>{sourceRef}</p>
        <p className={styles.caption}>
          이 원본을 후보에서 내립니다. 탐색이 같은 주소를 다시 찾아도 제안하지 않으며 되돌릴 수
          없습니다.
        </p>
        <div className={styles.fields}>
          <Field label="사유 (선택)" layout="stack" disabled={submitting}>
            <TextInput
              fullWidth
              placeholder="예) 변환 산출물이 아니다"
              value={reason}
              onChange={(event) => onReasonChange(event.target.value)}
            />
          </Field>
        </div>
        {errorMessage === null ? null : (
          <p className={styles.error} role="alert">
            {errorMessage}
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className={styles.actions}>
          <IconButton
            disabled={submitting}
            text="취소"
            tone="neutral"
            type="button"
            variant="surface"
            onClick={onCancel}
          />
          <IconButton
            disabled={submitting}
            text={submitting ? "폐기하는 중" : "폐기"}
            tone="danger"
            type="button"
            variant="solid"
            onClick={onConfirm}
          />
        </div>
      </Modal.Footer>
    </Modal>
  );
}
